export const THUMB_TYPES = {
  UP: 'Up',
  DOWN: 'Down',
};

export const THUMB_STYLES = {
  LIGHT: 'Light',
  DARK: 'Dark',
  SWITCH: 'Switch',
};

export const THUMB_LOCATIONS = {
  BACKSTAGE: 'backstage',
};
